import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Portfolio.css';

const CARDS = [
  {
    to: '/projects/stanton-basement-mold-restoration/',
    cats: 'Proposal Support,Compliance',
    label: 'Mold remediation site — VA facility',
    img: '/images/construction-site.jpg',
    badges: [{ text: 'Proposal Support', red: true }, { text: 'Compliance' }],
    agency: 'Dept. of Veterans Affairs',
    title: 'Government Mold Remediation Contract',
    value: '$70K',
    awarded: 'Awarded 2024',
  },
  {
    to: '/projects/coast-guard-elevator-maintenance/',
    cats: 'Subcontract,Facilities',
    label: 'Federal building elevator servicing',
    img: '/images/logistics-depot.jpg',
    badges: [{ text: 'Subcontract' }, { text: 'Facilities' }],
    agency: 'U.S. Coast Guard (DHS)',
    title: 'Elevator Maintenance & Inspection',
    value: '$3.6K',
    awarded: 'Awarded 2025',
  },
  {
    to: '#',
    cats: 'Grounds,Subcontract',
    label: 'Reservoir grounds maintenance',
    img: '/images/crane-sunset.jpg',
    badges: [{ text: 'Grounds' }, { text: 'Subcontract' }],
    agency: 'U.S. Army Corps of Engineers',
    title: 'Lake Mowing & Grounds Maintenance',
    value: '$92K',
    awarded: 'Awarded 2024',
  },
  {
    to: '#',
    cats: 'Skilled Trades,Compliance',
    label: 'Electrical repair on federal site',
    img: '/images/owner-laptop.jpg',
    badges: [{ text: 'Skilled Trades' }, { text: 'Compliance' }],
    agency: 'Dept. of the Interior',
    title: 'Electrical Repair Services',
    value: '$213K',
    awarded: 'Awarded 2025',
  },
  {
    to: '#',
    cats: 'IT Services,GSA',
    label: 'Software engineering team at work',
    img: '/images/team-meeting.jpg',
    badges: [{ text: 'IT Services' }, { text: 'GSA' }],
    agency: 'Dept. of Commerce',
    title: 'Backend Web Development',
    value: '$305K',
    awarded: 'Awarded 2025',
  },
  {
    to: '#',
    cats: 'Analytics',
    label: 'Analyst reviewing federal data',
    img: '/images/document-review.jpg',
    badges: [{ text: 'Analytics' }],
    agency: 'Health & Human Services',
    title: 'Data Analysis & Reporting',
    value: '$176K',
    awarded: 'Awarded 2025',
  },
  {
    to: '#',
    cats: 'IT Services,Data',
    label: 'Database infrastructure',
    img: '/images/location-pins.jpg',
    badges: [{ text: 'IT Services' }, { text: 'Data' }],
    agency: 'Dept. of Education',
    title: 'Centralized Database Build',
    value: '$264K',
    awarded: 'Awarded 2024',
  },
  {
    to: '#',
    cats: 'Construction,Prime',
    label: 'Federal construction site',
    img: '/images/construction-site.jpg',
    badges: [{ text: 'Construction', red: true }, { text: 'Prime' }],
    agency: 'U.S. Army Corps of Engineers',
    title: 'Site Construction & Logistics',
    value: '$3.1M',
    awarded: 'Awarded 2024',
  },
];

const FILTERS = [
  { f: 'all', label: 'All Projects' },
  { f: 'Proposal Support', label: 'Proposal Support' },
  { f: 'Compliance', label: 'Compliance' },
  { f: 'IT Services', label: 'IT Services' },
  { f: 'Construction', label: 'Construction' },
  { f: 'Subcontract', label: 'Subcontract' },
];

function Portfolio() {
  const [filter, setFilter] = useState('all');

  return (
    <main id="top">
      <section className="pf-hero">
        <div className="wrap-wide">
          <nav className="crumb"><Link to="/">Home</Link><span className="sep">/</span><b>Portfolio</b></nav>
          <div className="pf-hero-inner">
            <span className="eyebrow">Portfolio & past performance</span>
            <h1>Real federal contracts.<br/>Real <em style={{ color: 'rgb(246, 176, 30)' }}>results.</em></h1>
            <p className="sub">A selection of registrations, certifications, and subcontract awards we've helped small businesses secure across federal agencies — from proposal preparation to full compliance support.</p>
            <div className="ha">
              <a className="btn btn-light" href="#work">Browse Projects <span className="arw">→</span></a>
              <a className="btn btn-outline-light" href="/contact-us/">Start Your Project</a>
              <span className="rate"><span className="stars"><svg className="ico"><use href="#i-star" /></svg><svg className="ico"><use href="#i-star" /></svg><svg className="ico"><use href="#i-star" /></svg><svg className="ico"><use href="#i-star" /></svg><svg className="ico"><use href="#i-star" /></svg></span> <b>4.9/5</b> · 2,400+ businesses</span>
            </div>
          </div>
          <div className="pf-statrow">
            <div className="s"><b>120<em>+</em></b><span>Contracts & bids supported</span></div>
            <div className="s"><b>$40M<em>+</em></b><span>In contract value pursued</span></div>
            <div className="s"><b>30<em>+</em></b><span>Federal agencies engaged</span></div>
            <div className="s"><b>98<em>%</em></b><span>Submission compliance rate</span></div>
          </div>
        </div>
        <div className="flagstripe"><i /><i /><i /><i /><i /><i /><i /><i /><i /><i /><i /><i /><i /></div>
      </section>

      <section className="pf-work sec-pad" id="work">
        <div className="wrap-wide">
          <div className="sec-head">
            <span className="kicker-num">Selected work</span>
            <h2>Past performance across the federal marketplace.</h2>
            <p className="lead">Every engagement below reflects real proposal, compliance, and registration work delivered for small-business clients pursuing federal contracts.</p>
          </div>
          <div className="pf-filter" id="pf-filter">
            {FILTERS.map((c) => (
              <button
                key={c.f}
                className={`pf-chip${filter === c.f ? ' active' : ''}`}
                data-f={c.f}
                onClick={() => setFilter(c.f)}
              >
                {c.label}
              </button>
            ))}
          </div>
          <div className="pf-grid" id="pf-grid">
            {CARDS.map((card, i) => {
              const visible = filter === 'all' || card.cats.split(',').indexOf(filter) > -1;
              const inner = (
                <>
                  <div className="pf-media"><img className="ph" src={card.img} alt={card.label} />
                    <div className="pf-cat">{card.badges.map((b, bi) => (
                      <span key={bi} className={b.red ? 'red' : undefined}>{b.text}</span>
                    ))}</div>
                  </div>
                  <div className="pf-body">
                    <div className="pf-agency"><svg className="ico"><use href="#i-landmark" /></svg> {card.agency}</div>
                    <h3>{card.title}</h3>
                    <div className="pf-metar"><span className="v">{card.value}</span><span className="d">{card.awarded}</span></div>
                    <span className="lk">View project <span className="arw">→</span></span>
                  </div>
                </>
              );
              const style = visible ? undefined : { display: 'none' };
              return card.to.startsWith('#') ? (
                <a key={i} className="pf-card" href={card.to} data-cat={card.cats} style={style}>{inner}</a>
              ) : (
                <Link key={i} className="pf-card" to={card.to} data-cat={card.cats} style={style}>{inner}</Link>
              );
            })}
          </div>
        </div>
      </section>

      <section className="finalcta" id="contact">
        <div className="wrap">
          <span className="starrow center" style={{ marginBottom: '24px' }}><svg viewBox="0 0 24 24"><use href="#i-star" /></svg><svg viewBox="0 0 24 24"><use href="#i-star" /></svg><svg viewBox="0 0 24 24"><use href="#i-star" /></svg></span>
          <img className="brand-logo" style={{ height: '60px', margin: '0 auto' }} src="/atz-logo-white.png" alt="ATZ Solution" />
          <span className="eyebrow">Let's make things happen</span>
          <h2>Your business could be our next success story.</h2>
          <p>Whether you're registering for the first time or pursuing your next federal award, our specialists handle the hard part. Book a free consultation and let's map your path to a contract.</p>
          <div className="hero-actions">
            <a className="btn btn-light" href="/contact-us/">Book a Free Consultation <span className="arw">→</span></a>
            <a className="btn btn-outline-light" href="/contact-us/">Talk to a Specialist</a>
          </div>
          <div className="call">Prefer to talk now? Call <b>(704) 459-8642</b> · Mon–Fri 9:00–6:00 ET</div>
        </div>
      </section>
    </main>
  );
}

export default Portfolio;
